export const IMAGE_MODE_FLAG = 1;
export const COLOR_MODE_FLAG = 2;
export const GRADIENT_MODE_FLAG = 4;
